var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "详情",
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "50%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-align-center margin-bottom-20" },
        [
          _c(
            "div",
            { staticClass: "title-box", staticStyle: { "margin-bottom": "0" } },
            [_vm._v("基本信息")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.lookActive(_vm.info.id)
                },
              },
            },
            [_vm._v("预览")]
          ),
        ],
        1
      ),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "活动状态" } }, [
            _c("div", [_vm._v(_vm._s(_vm.info.activeStatus))]),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "活动类型" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { margin: "0 10px", width: "500px" },
                  attrs: {
                    data: _vm.info.typeList,
                    border: "",
                    size: "mini",
                    "max-height": "280px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "活动类型",
                      prop: "typeName",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "参与条件",
                      align: "center",
                      prop: "conditions",
                    },
                  }),
                  _vm.info.type !== 1
                    ? _c("el-table-column", {
                        attrs: {
                          label: "有效线路",
                          align: "center",
                          prop: "lineName",
                        },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      label: "限制参与用户",
                      align: "center",
                      prop: "restrictedUser",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-descriptions-item", { attrs: { label: "活动名称" } }, [
            _c("div", [_vm._v(_vm._s(_vm.info.name))]),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动时间" } }, [
            _vm._v(
              _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动规则" } }, [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.info.description) },
            }),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动链接" } }, [
            _c("div", { staticClass: "flex-col" }, [
              _c(
                "div",
                { staticClass: "flex flex-align-center" },
                [
                  _c("div", { staticClass: "url-box" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          "/pages/user/prizeDraw/index?goIndex=1&activeId=" +
                            _vm.info.id
                        ) +
                        "\n          "
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.copyUrl(
                            "/pages/user/prizeDraw/index?goIndex=1&activeId=" +
                              _vm.info.id
                          )
                        },
                      },
                    },
                    [_vm._v("复制")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "margin-top-10" },
                [
                  _c("vue-qr", {
                    attrs: {
                      logoScale: 0.2,
                      logoMargin: 1,
                      text: _vm.qrCode,
                      margin: 0,
                      size: 80,
                    },
                  }),
                  _c("div", [_vm._v("微信扫码直达活动页面")]),
                  _c("div", [_vm._v("渠道链接:" + _vm._s(_vm.qrCode))]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm.info.type !== 4
        ? [
            _c("div", { staticClass: "title-box" }, [_vm._v("页面样式")]),
            _c(
              "el-descriptions",
              { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
              [
                _c(
                  "el-descriptions-item",
                  { attrs: { label: "页面头图" } },
                  [
                    _c("el-image", {
                      staticStyle: { width: "120px", "margin-left": "30px" },
                      attrs: {
                        src: _vm.info.images,
                        "preview-src-list": [_vm.info.images],
                      },
                    }),
                  ],
                  1
                ),
                _c("el-descriptions-item", { attrs: { label: "页面背景色" } }, [
                  _vm._v(_vm._s(_vm.info.backgroundColor)),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("div", { staticClass: "title-box" }, [_vm._v("活动奖品")]),
      _c(
        "el-table",
        {
          staticStyle: { margin: "0 10px" },
          attrs: {
            data: _vm.info.prizes,
            border: "",
            size: "mini",
            "max-height": "280px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              type: "index",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "奖品名称", align: "center", prop: "prizeName" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "奖品数量（已中奖量/奖品库存量）",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.winNumbers) +
                        "/" +
                        _vm._s(scope.row.stockNumbers) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "中奖概率", align: "center", prop: "winnerRate" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.winnerRate))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "排序", align: "center", prop: "sort" },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "title-box margin-top-20" }, [
        _vm._v("分享信息"),
      ]),
      _c(
        "el-descriptions",
        { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
        [
          _c("el-descriptions-item", { attrs: { label: "标题" } }, [
            _vm._v(_vm._s(_vm.info.shareTitle)),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "分享图" } },
            [
              _c("el-image", {
                staticStyle: { width: "120px", "margin-left": "30px" },
                attrs: {
                  src: _vm.info.shareImages,
                  "preview-src-list": [_vm.info.shareImages],
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "title-box" }, [_vm._v("其他")]),
      _c(
        "div",
        { staticClass: "bottom-box" },
        [
          _c(
            "el-descriptions",
            { staticStyle: { "margin-left": "40px" }, attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
                _vm._v(_vm._s(_vm.info.createUser)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "操作人" } }, [
                _vm._v(_vm._s(_vm.info.updateUser)),
              ]),
            ],
            1
          ),
          _c(
            "el-descriptions",
            { attrs: { column: 1 } },
            [
              _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
                _vm._v(_vm._s(_vm.info.createTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "操作时间" } }, [
                _vm._v(_vm._s(_vm.info.updateTime)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }